/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service.applicability
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: code_applicability.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as code_applicability_pb from './code_applicability_pb'; // proto import: "code_applicability.proto"


export class CodeApplicabilityServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorStartCodeApplicabilityAnalysisTask = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.applicability.CodeApplicabilityService/StartCodeApplicabilityAnalysisTask',
    grpcWeb.MethodType.UNARY,
    code_applicability_pb.StartCodeApplicabilityAnalysisRequest,
    code_applicability_pb.StartCodeApplicabilityAnalysisResponse,
    (request: code_applicability_pb.StartCodeApplicabilityAnalysisRequest) => {
      return request.serializeBinary();
    },
    code_applicability_pb.StartCodeApplicabilityAnalysisResponse.deserializeBinary
  );

  startCodeApplicabilityAnalysisTask(
    request: code_applicability_pb.StartCodeApplicabilityAnalysisRequest,
    metadata?: grpcWeb.Metadata | null): Promise<code_applicability_pb.StartCodeApplicabilityAnalysisResponse>;

  startCodeApplicabilityAnalysisTask(
    request: code_applicability_pb.StartCodeApplicabilityAnalysisRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: code_applicability_pb.StartCodeApplicabilityAnalysisResponse) => void): grpcWeb.ClientReadableStream<code_applicability_pb.StartCodeApplicabilityAnalysisResponse>;

  startCodeApplicabilityAnalysisTask(
    request: code_applicability_pb.StartCodeApplicabilityAnalysisRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: code_applicability_pb.StartCodeApplicabilityAnalysisResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.applicability.CodeApplicabilityService/StartCodeApplicabilityAnalysisTask',
        request,
        metadata || {},
        this.methodDescriptorStartCodeApplicabilityAnalysisTask,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.applicability.CodeApplicabilityService/StartCodeApplicabilityAnalysisTask',
    request,
    metadata || {},
    this.methodDescriptorStartCodeApplicabilityAnalysisTask);
  }

}

